import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { CURRENT_USER_DETAILS } from "@Client/@Modules/main/store/account/account-getters";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddDocumentComment",
  components: {
    ProfileAvatar
  },
  mixins: [validationMixin],
  validations: {
    comment: {
      required
    }
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      comment: ""
    };
  },
  computed: _objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_DETAILS])),
  methods: {
    handleCommentSubmit() {
      if (this.$v.$invalid) return;
      this.$emit("submit", {
        comment: this.comment
      });
      this.comment = "";
    }
  }
});